import React, { useContext } from 'react'
import { Avatar, Badge, styled } from '@mui/material'
import { UserInfoContext } from '../contexts/UserInfoContext'

export const CommunityPageAvatar = ({ src, communityId, ...props }) => {
  const tempAvatarNickname = communityId.slice(0, 1).toUpperCase()
  return (
    <>
      {src
        ? (
          <Avatar alt="user icon" sx={{ width: 80, height: 80, mt: '-3.5rem', ml: '1rem', border: '4px solid black', ...props }} src={src} />
          )
        : (
          <Avatar alt="user icon" sx={{ width: 80, height: 80, mt: '-3.5rem', ml: '1rem', border: '4px solid black', ...props }}>{tempAvatarNickname}</Avatar>
          )
      }
    </>
  )
}

export const ViewProfileAvatar = ({ src, nickname }) => {
  const tempAvatarNickname = nickname?.slice(0, 1).toUpperCase()
  return (
    <>
      {src
        ? (
          <Avatar alt="user icon" sx={{
            width: 70,
            height: 70,
            border: '2px solid',
            borderColor: 'grey.800'
          }} src={src} />
          )
        : (
          <Avatar alt="user icon" sx={{
            width: 70,
            height: 70,
            border: '2px solid',
            borderColor: 'grey.800'
          }}>
            {tempAvatarNickname}
          </Avatar>
          )
      }
    </>
  )
}

export const CommunityAvatar = ({ src, communityId, ...props }) => {
  const tempAvatarNickname = communityId?.slice(0, 1).toUpperCase()
  return (
    <>
      {src
        ? (
          <Avatar alt="user icon" sx={{ width: 24, height: 24, ...props }} src={src} />
          )
        : (
          <Avatar alt="user icon" sx={{ width: 24, height: 24, ...props }}>{tempAvatarNickname}</Avatar>
          )
      }
    </>
  )
}

export const UserAvatar = ({ src, nickname }) => {
  const tempAvatarNickname = nickname?.slice(0, 1).toUpperCase()
  return (
    <>
      {src
        ? (
          <Avatar alt="user icon" sx={{ width: 24, height: 24 }} src={src} />
          )
        : (
          <Avatar alt="user icon" sx={{ width: 24, height: 24 }}>{tempAvatarNickname}</Avatar>
          )
      }
    </>
  )
}

export const ActiveAvatar = ({ src }) => {
  const { userInfo } = useContext(UserInfoContext)
  const tempAvatarNickname = userInfo.nickname?.slice(0, 1).toUpperCase()

  const ActiveBadge = styled(Badge)(({ theme }) => ({
    '& .MuiBadge-badge': {
      backgroundColor: '#44b700',
      color: '#44b700',
      boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
      '&::after': {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        borderRadius: '50%',
        animation: 'ripple 1.2s infinite ease-in-out',
        border: '1px solid currentColor',
        content: '""'
      }
    },
    '@keyframes ripple': {
      '0%': {
        transform: 'scale(.8)',
        opacity: 1
      },
      '100%': {
        transform: 'scale(2.4)',
        opacity: 0
      }
    }
  }))

  return (
    <ActiveBadge
        overlap="circular"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        variant="dot"
    >
      {src
        ? (
          <Avatar alt="user icon" sx={{ width: 32, height: 32 }} src={src} />
          )
        : (
          <Avatar alt="user icon" sx={{ width: 32, height: 32 }}>{tempAvatarNickname}</Avatar>
          )
      }
    </ActiveBadge>
  )
}
